<template>
  <v-container grid-list-md pa-0 relative>
    <v-layout row wrap>
      <v-flex xs12 sm12>
        <v-card outlined class="primary--border">
          <v-card-title class="title">
            Opening
            <span class="opening-setting-head"><v-menu offset-y transition="slide-y-reverse-transition">
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" text>{{ selected_statement_type }}
                    <v-icon ml-2>arrow_drop_down</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-subheader>Select Type</v-subheader>
                  <v-list-item v-for="(item, index) in statementTypes" :key="index"
                    @click="selected_statement_type = item">
                    <v-list-item-title>{{ item }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </span>
            <v-spacer></v-spacer>

          </v-card-title>
          <PreviousDue v-if="selected_statement_type === 'Previous Dues'" :reuseComponent="true" />
          <Advance v-if="selected_statement_type === 'Advance'" :reuseComponent="true" />

        </v-card>
      </v-flex>

    </v-layout>
  </v-container>
</template>
<script>
import { mapState } from "vuex";

import PreviousDue from '../PreviousDue/index.vue'
import Advance from '../AdvanceJournal/index.vue'

export default {
  components: { PreviousDue, Advance },
  data: () => ({
    statement_types: ["Previous Dues", "Advance"],
    selected_statement_type: "Previous Dues"
  }),

  computed: {
    ...mapState(["batch"]),
    statementTypes() {
      let $this = this;
      return this.statement_types.filter(function (statement) {
        return $this.selected_statement_type !== statement;
      });
    },
  },



  methods: {
    editSOD(item) {
      this.form.edit(item);
    },
  },
};
</script>
<style lang="scss">
.opening-setting-head {
  .v-menu__activator--active {
    background-color: transparent !important;
  }

  .v-btn {
    padding-left: 0px;
  }

  .v-btn__content {
    color: black !important;
    font-size: 20px;
    padding-left: 0 !important;
    text-transform: capitalize;
    // font-weight: bold !important;
    border-bottom: 2px solid #666;
  }

  button {
    padding-left: 10px !important;
    padding-right: 5px !important;
  }
}
</style>
